import { gsap, ScrollTrigger } from 'gsap/all';
import SplitText from "../__vendor/SplitText.min.js";

gsap.registerPlugin(ScrollTrigger);

const sectionServices = () => {
    const services = document.querySelectorAll('.service-items > svg'); 

    services.forEach((process, index) => {
        const textElement = process.querySelector('.service-item-text');
        const splitText = new SplitText(textElement, { type: "chars" });

        gsap.set(splitText.chars, {
            autoAlpha: 0,
            y: 15
        });

        const sectionServicesTl = gsap.timeline({
            paused: true
        });

        sectionServicesTl.set(process, {
            onStart: () => process.classList.add('active'), 
        }, `+=${index * 0.225}`).to(splitText.chars, {
            autoAlpha: 1,
            y: 0,
            stagger: 0.05,
        }, `+=${index * 0.125}`);

        ScrollTrigger.create({
            scroller:'[data-scroll-container]',
            trigger: process,
            start: 'top bottom-=200',
            end: 'bottom top',
            animation: sectionServicesTl,
            toggleActions: 'play none none none',
        });
    });
};

export default sectionServices;
